/**
 * ProductStatusRibbon (formerly LiveStatsRibbon) — factual product-status tiles.
 * No fabricated platform metrics; only defensible statements.
 */
import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

export default function LiveStatsRibbon() {
  const { language } = useLanguage();
  const isTR = language === "tr";

  const tiles = [
    { value: isTR ? "Beta" : "Beta", label: isTR ? "Erken Erişim" : "Early Access", testId: "status-beta" },
    { value: isTR ? "İzlenebilir" : "Traceable", label: isTR ? "İnceleme Kapıları" : "Review Gates", testId: "status-validation-gates" },
    { value: isTR ? "Gerekli" : "Required", label: isTR ? "İnsan Doğrulaması" : "Human Validation", testId: "status-validation" },
    { value: isTR ? "Ön" : "Preliminary", label: isTR ? "Mühendislik Çıktıları" : "Engineering Outputs", testId: "status-outputs" },
    { value: "PDF · DXF", label: isTR ? "Doğrulanmış Veriye Bağlı Dışa Aktarım" : "Export Subject to Verified Data", testId: "status-export" },
    { value: isTR ? "Açık" : "Open", label: isTR ? "Gerçek Zamanlı Doğrulama Kapıları" : "Real-Time Validation Gates", testId: "status-gates" },
  ];

  return (
    <div className="mb-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/10"
        data-testid="product-status-ribbon"
      >
        {tiles.map((t) => (
          <div key={t.testId} className="bg-[#0A0D1A] p-8 lg:p-10 text-center" data-testid={t.testId}>
            <div className="text-2xl lg:text-3xl font-bold text-white tracking-tight">{t.value}</div>
            <div className="mt-2 text-[11px] font-mono uppercase tracking-[0.18em] text-white/60">{t.label}</div>
          </div>
        ))}
      </motion.div>
      <p className="mt-3 text-[10px] font-mono uppercase tracking-widest text-white/60" data-testid="status-disclaimer-note">
        {isTR
          ? "Nexus çıktıları ön karar-destek niteliğindedir; üretim öncesi nitelikli mühendislik incelemesi ve doğrulaması gerektirir."
          : "Nexus outputs are preliminary decision support; qualified human engineering review and validation are required before production."}
      </p>
    </div>
  );
}
